// src/algorithms/index.ts
import type { DitherAlgorithm } from '../core/types';
import { ERROR_DIFFUSION_ALGORITHMS } from './error-diffusion';
import { ORDERED_ALGORITHMS } from './ordered';
import { HALFTONE_ALGORITHMS } from './halftone';

export const ALL_ALGORITHMS: DitherAlgorithm[] = [
  ...ERROR_DIFFUSION_ALGORITHMS,
  ...ORDERED_ALGORITHMS,
  ...HALFTONE_ALGORITHMS,
];
